<template>
  <div class="tabs-column user-tabs-column userfilterscustom">
    <el-tabs type="border-card" v-model="tabsValue">
      <el-tab-pane :label="item.name" :name="index" v-for="(item, index) in filters" :class="'tab' + index" :key="index" :style="tabsInit === '1' && index !== 'user_attr' ? 'display:none' : 'display:block'">
        <dufault-column-user-filters height="auto" title="">
          <div slot="bar">
            <dates-picker :allDate="true" v-if="chooseVal[index] && chooseVal[index]['child_time']" @input="changeValue" v-model="chooseVal[index]['child_time']" size="small"></dates-picker>
            <p class="adelete font12 alignR" v-if="chooseVal[index] && chooseVal[index]['child_time'] && !chooseVal[index]['child_time'].length && checkDate[index]">请选择时间</p>
          </div>
          <div slot="content">
            <div class="filtersbox auto">
              <div v-if="item['is_child'] && onlyObjects[index] !== 'undefined'" class="filters-only-options">
                <el-select filterable v-model="onlyObjects[index]" size="small" placeholder="请选择分类" @change="changeOnly(index)">
                  <el-option
                    v-for="item in onlyOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="filtersitem auto" v-for="(item2, index2) in item.filter" :key="index2" v-if="item['is_child'] ? index2 === onlyObjects[index] : true">
                <div v-if="item2.html_type === 'multi_select'">
                  <p class="multip boxsizing">
                    <span>{{item2.name}}</span>
                    <el-input v-if="search[index] && (search[index][index2] || search[index][index2] === '')" v-model="search[index][index2]" placeholder="搜索" size="small" prefix-icon="el-icon-search" clearable style="width: 200px;float: right;text-indent:0;" @change="searchHandle(search[index][index2], index2)"></el-input>
                  </p>
                  <div class="filterscroll auto" v-show="search[index] && search[index][index2] === ''">
                    <div class="filtersitem auto" v-if="item2.list" v-for="(item3, index3) in item2.list" :key="index3">
                      <div class="filterstitle auto boxsizing ellipsis" :title="item3.group_name">{{item3.group_name}}</div>
                      <div class="filterscon auto">
                        <div class="filtersconbox auto">
                          <div class="filtersconboxul boxsizing">
                            <ul>
                              <li v-for="(item4, index4) in item3.child" :key="index4" v-if="chooseVal[tabsValue] && chooseVal[tabsValue]['filter'][index2]" :class="chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === item4.event_id }) > -1 ? 'cur' : ''" @click="clickItem($event, index2, item4.event_id, item4.event_name)">{{item4.event_name}}</li>
                            </ul>
                          </div>
                          <a href="javascript:;" class="alink alinkmore">更多<span>∨</span></a>
                          <a href="javascript:;" class="alink alinkhide" style="display: none;">收起<span>∧</span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filterscroll auto" v-show="search[index] && search[index][index2] !== ''" v-if="searchData[index] && searchData[index]['filter']">
                    <div class="filtersitem auto" v-for="(item3, index3) in searchData[index]['filter'][index2].list" :key="index3">
                      <div class="filterstitle auto boxsizing ellipsis" :title="item3.group_name">{{item3.group_name}}</div>
                      <div class="filterscon auto">
                        <div class="filtersconbox auto">
                          <div class="filtersconboxul boxsizing">
                            <ul>
                              <li v-for="(item4, index4) in item3.child" :key="index4" v-if="chooseVal[tabsValue] && chooseVal[tabsValue]['filter'][index2]" :class="chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === item4.event_id }) > -1? 'cur' : ''" @click="clickItem($event, index2, item4.event_id, item4.event_name)">{{item4.event_name}}</li>
                            </ul>
                          </div>
                          <a href="javascript:;" class="alink alinkmore">更多<span>∨</span></a>
                          <a href="javascript:;" class="alink alinkhide" style="display: none;">收起<span>∧</span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="filterstitle auto boxsizing ellipsis" :title="item2.name">{{item2.name}}</div>
                  <div class="filterscon auto">
                    <div class="filtersconbox auto" v-if="item2.html_type === 'li'">
                      <div class="filtersconboxul boxsizing">
                        <ul>
                          <li v-for="(item3, index3) in item2.list" :key="index3" v-if="chooseVal[tabsValue] && chooseVal[tabsValue]['filter'][index2]" :class="chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === index3 }) > -1 ? 'cur' : ''" @click="clickItem($event, index2, index3, item3)">{{item3}}</li>
                        </ul>
                      </div>
                      <a href="javascript:;" class="alink alinkmore">更多<span>∨</span></a>
                      <a href="javascript:;" class="alink alinkhide" style="display: none;">收起<span>∧</span></a>
                    </div>
                    <div class="filtersconbox auto li_search" v-if="item2.html_type === 'li_search'">
                      <div class="filtersconboxul boxsizing">
                        <ul>
                          <li v-for="(item3, index3) in item2.list" :key="index3" v-if="chooseVal[tabsValue] && chooseVal[tabsValue]['filter'][index2]" :class="chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === index3 }) > -1 ? 'cur' : ''" @click="clickItem($event, index2, index3, item3)">{{item3}}</li>
                        </ul>
                        <ul style="display: none;" v-if="search[index]">
                          <li style="width:100%;margin-left:0;text-align:right;padding-bottom: 10px;"><el-input v-if="search[index] && (search[index][index2] || search[index][index2] === '')" v-model="search[index][index2]" placeholder="搜索" size="small" prefix-icon="el-icon-search" clearable style="width: 200px;float: right;text-indent:0;" @focus="focusHandle($event, index2)" @change="searchHandle(search[index][index2], index2)"></el-input></li>
                          <li v-for="(item3, index3) in item2.list" :key="index3" v-if="chooseVal[tabsValue] && search[index][index2] === ''" :class="chooseVal[tabsValue]['filter'][index2] && chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === index3 }) > -1 ? 'cur' : ''" @click="clickItem($event, index2, index3, item3)">{{item3}}</li>
                          <li v-for="(item3, index3) in searchData[index]['filter'][index2].list" :key="index3" v-if="chooseVal[tabsValue] && search[index][index2] !== ''" :class="chooseVal[tabsValue]['filter'][index2] && chooseVal[tabsValue]['filter'][index2]['value'].findIndex(value => { return value.value === index3 }) > -1 ? 'cur' : ''" @click="clickItem($event, index2, index3, item3)">{{item3}}</li>
                        </ul>
                      </div>
                      <a href="javascript:;" class="alink alinkmore">更多<span>∨</span></a>
                      <a href="javascript:;" class="alink alinkhide" style="display: none;">收起<span>∧</span></a>
                    </div>
                    <div class="filtersconbox auto" v-if="item2.html_type === 'input'">
                      <div class="filtersconboxul boxsizing">
                        <ul>
                          <li v-for="(item3, index3) in item2.list" :key="index3">
                            <el-input v-if="chooseVal[index] && chooseVal[index]['filter'] && (chooseVal[index]['filter'][index2] || chooseVal[index]['filter'][index2]['value'] === '')" clearable v-model="chooseVal[index]['filter'][index2]['value']" @change="changeValue" :placeholder="item3" size="small"></el-input>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="filtersconbox auto" v-if="item2.html_type === 'datetime'">
                      <div class="filtersconboxul boxsizing">
                        <ul>
                          <li>
                            <dates-picker :allDate="true" v-if="chooseVal[index] && chooseVal[index]['filter'] && chooseVal[index]['filter'][index2]['value']" @input="changeValue" v-model="chooseVal[index]['filter'][index2]['value']" size="small"></dates-picker>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="filterbtn auto" v-if="!nobtn">
              <el-button type="primary" size="small" @click="submitValues(index)">确定</el-button>
              <el-button size="small" @click="resetValues($event)">重置</el-button>
              <el-button size="small" @click="closeFn">取消</el-button>
            </div>
          </div>
        </dufault-column-user-filters>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'userFilters',
  props: [
    'filters',
    'chooseValDemo',
    'allReadyChoose'
  ],
  data () {
    return {
      nobtn: false,
      filterTags: {},
      dataStr: {},
      chooseValStr: {},
      tabsValue: 'user_attr',
      tabsInit: '',
      copyDataStr: {},
      chooseVal: {},
      search: {},
      searchData: {},
      searchObj: {
        keyword: '',
        group: ''
      },
      checkTime: [
        'user_behavior',
        'h5',
        'rd'
      ],
      checkDate: {},
      onlyOptions: [],
      onlyObjects: {}
    }
  },
  watch: {
    'tabsValue': function (val) {
      setTimeout(() => {
        this.showMoreBtn()
      })
      var allMore = $('.alinkmore')
      for (let i = 0; i < allMore.length; i++) {
        let item = allMore[i]
        if ($(item).parent().find('ul').length > 1) {
          $(item).parent().find('ul').eq(0).show()
          $(item).parent().find('ul').eq(1).hide()
        }
      }
    },
    'filters': function (val) {
      setTimeout(() => {
        this.showMoreBtn()
      })
      this.searchData = JSON.parse(JSON.stringify(val))
      for (let key in val) {
        this.search[key] = {}
        if (val[key]['filter']) {
          for (let k in val[key]['filter']) {
            this.search[key][k] = ''
          }
        }
      }
      this.initData(val)
      if (JSON.stringify(this.allReadyChoose['filter']) !== '{}') {
        this.initChoose(val)
      }
      this.search = JSON.parse(JSON.stringify(this.search))
    },
    'allReadyChoose': function (val) {
      if (val && val['filter'] && JSON.stringify(val['filter']) !== '{}') {
        this.initChoose(this.filters)
      }
    },
    'dataStr': function (val) {
      if (JSON.stringify(this.allReadyChoose['filter']) !== '{}') {
        this.initChoose(this.filters)
      } else {
        this.chooseVal = JSON.parse(JSON.stringify(val))
      }
      this.copyDataStr = JSON.parse(JSON.stringify(val))
    },
    'search': function (val) {
      this.searchFn(this.searchObj.keyword, this.searchObj.group)
      if (this.searchData[this.tabsValue]['filter'][this.searchObj.group] && this.searchData[this.tabsValue]['filter'][this.searchObj.group]['html_type'] === 'li_search') {
        this.$nextTick(() => {
          $('.tab' + this.tabsValue + ' .li_search').eq(0).find('.filtersconboxul').height($('.tab' + this.tabsValue + ' .li_search').eq(0).find('ul').eq(1).height())
        })
      } else {
        setTimeout(() => {
          this.showMoreBtn()
        })
      }
    }
  },
  methods: {
    changeOnly (type) {
      let obj = JSON.parse(JSON.stringify(this.chooseVal[type]))
      for(let key in obj['filter']) {
        if (obj['filter'][key]['html_type'] === 'input') {
          obj['filter'][key]['value'] = ''
        } else {
          obj['filter'][key]['value'] = []
        }
      }
      this.chooseVal[type] = obj
    },
    initData (filter) {
      var dataStr = {}
      var onlyOptions = []
      for (let key in filter) {
        dataStr[key] = {}
        dataStr[key]['name'] = filter[key]['name']
        if (filter[key]['child_time']) {
          dataStr[key]['child_time'] = []
        }
        dataStr[key]['filter'] = {}
        for (let k in filter[key]['filter']) {
          if (filter[key]['filter'][k]['html_type'] === 'input') {
            dataStr[key]['filter'][k] = {
              name: filter[key]['filter'][k]['name'],
              value: ''
            }
          } else {
            dataStr[key]['filter'][k] = {
              name: filter[key]['filter'][k]['name'],
              value: []
            }
          }
          dataStr[key]['filter'][k]['html_type'] = filter[key]['filter'][k]['html_type']
        }
        if (filter[key]['is_child']) {
          this.onlyObjects[key] = ''
          this.onlyObjects = JSON.parse(JSON.stringify(this.onlyObjects))
          for (let k in filter[key]['filter']) {
            onlyOptions.push({
              name: filter[key]['filter'][k]['name'],
              value: k
            })
          }
        }
      }
      this.onlyOptions = onlyOptions
      this.dataStr = dataStr
    },
    initChoose (filter) {
      var dataStr = {}
      for (let key in filter) {
        this.checkDate[key] = false
        dataStr[key] = {}
        dataStr[key]['name'] = filter[key]['name']
        if (filter[key]['child_time']) {
          dataStr[key]['child_time'] = this.allReadyChoose['filter'][key]['child_time']
        }
        dataStr[key]['name'] = filter[key]['name']
        dataStr[key]['filter'] = {}
        for (let k in filter[key]['filter']) {
          if (filter[key]['filter'][k]['html_type'] === 'input') {
            dataStr[key]['filter'][k] = {
              name: filter[key]['filter'][k]['name'],
              value: this.allReadyChoose['filter'][key]['filter'][k]
            }
          } else if (filter[key]['filter'][k]['html_type'] === 'datetime') {
            dataStr[key]['filter'][k] = {
              name: filter[key]['filter'][k]['name'],
              value: this.allReadyChoose['filter'][key]['filter'][k]
            }
          } else {
            let obj = []
            this.allReadyChoose['filter'][key]['filter'][k].map((item, index) => {
              obj.push({
                name: filter[key]['filter'][k]['list'][item],
                value: item
              })
            })
            dataStr[key]['filter'][k] = {
              name: filter[key]['filter'][k]['name'],
              value: obj
            }
          }
          dataStr[key]['filter'][k]['html_type'] = filter[key]['filter'][k]['html_type']
        }
      }
      this.chooseVal = JSON.parse(JSON.stringify(dataStr))
    },
    focusHandle (e, group) {
      this.searchObj['group'] = group
    },
    searchHandle (keyword, group) {
      this.searchObj = {
        keyword: keyword,
        group: group
      }
      this.search = JSON.parse(JSON.stringify(this.search))
    },
    searchFn (keyword, group) {
      if (this.searchData[this.tabsValue]['filter'][group]) {
        if (this.searchData[this.tabsValue]['filter'][group]['html_type'] === 'li_search') {
          this.searchData[this.tabsValue]['filter'][group]['list'] = {}
          for (let key in this.filters[this.tabsValue]['filter'][group]['list']) {
            if (this.filters[this.tabsValue]['filter'][group]['list'][key].indexOf(keyword) > -1) {
              this.searchData[this.tabsValue]['filter'][group]['list'][key] = this.filters[this.tabsValue]['filter'][group]['list'][key]
            }
          }
        } else {
          this.searchData[this.tabsValue]['filter'][group]['list'] = []
          // this.filters[this.tabsValue]['filter'][group]['list'].map((item, index) => {
          //   this.searchData[this.tabsValue]['filter'][group]['list'].push({
          //     child: [],
          //     group_id: item.group_id,
          //     group_name: item.group_name
          //   })
          //   item.child.map((item2, index2) => {
          //     if (item2['event_name'].indexOf(keyword) > -1) {
          //       this.searchData[this.tabsValue]['filter'][group]['list'][index]['child'].push({
          //         event_id: item2.event_id,
          //         event_name: item2.event_name
          //       })
          //     }
          //   })
          // })
          let index = 0
          for (let key in this.filters[this.tabsValue]['filter'][group]['list']) {
            let item = this.filters[this.tabsValue]['filter'][group]['list'][key]
            // let index = key
            // console.log('group', group)
            this.searchData[this.tabsValue]['filter'][group]['list'].push({
              child: [],
              group_id: item.group_id,
              group_name: item.group_name
            })
            this.searchData = JSON.parse(JSON.stringify(this.searchData))
            // console.log('113', this.searchData[this.tabsValue]['filter'][group])
            item.child.map((item2, index2) => {
              if (item2['event_name'].indexOf(keyword) > -1) {
                // console.log(item2['event_name'], index)
                // console.log(this.searchData[this.tabsValue]['filter'][group]['list'])
                this.searchData[this.tabsValue]['filter'][group]['list'][index]['child'].push({
                  event_id: item2.event_id,
                  event_name: item2.event_name
                })
              }
            })
            index++
          }
          this.hideEmpty(group)
        }
        this.searchData = JSON.parse(JSON.stringify(this.searchData))
      }
    },
    hideEmpty (group) {
      this.searchData[this.tabsValue]['filter'][group]['list'].map(item => {
        if (!item.child.length) {
          var index = this.searchData[this.tabsValue]['filter'][group]['list'].indexOf(item)
          this.searchData[this.tabsValue]['filter'][group]['list'].splice(index, 1)
          this.hideEmpty(group)
          return false
        }
      })
    },
    showMoreBtn () {
      var allMore = $('.alinkmore')
      for (let i = 0; i < allMore.length; i++) {
        let item = allMore[i]
        if ($(item).parent().find('ul').eq(0).height() <= 45) {
          $(item).hide()
          $(item).siblings('.alinkhide').hide()
        } else {
          $(item).show()
          $(item).siblings('.alinkhide').hide()
          $(item).parents('.filtersbox').find('.filtersconboxul').css('height', '45px')
        }
      }
      setTimeout(() => {
        this.tabsInit = '1'
      })
    },
    changeValue () {
      // this.chooseVal = JSON.parse(JSON.stringify(this.chooseVal))
      if (this.nobtn) {
        this.submitValues(this.tabsValue)
      }
    },
    clickItem (e, attr, id, name) {
      var item = e.target
      var group = this.chooseVal[this.tabsValue]['filter'][attr]['value']
      if ($(item).hasClass('cur')) {
        var index = this.chooseVal[this.tabsValue]['filter'][attr]['value'].findIndex(value => {
          return value.value === id
        })
        if (index > -1) {
          group.splice(index, 1)
        }
      } else {
        group.push({
          name: name,
          value: id
        })
      }
      this.chooseVal = JSON.parse(JSON.stringify(this.chooseVal))
      if (this.nobtn) {
        this.submitValues(this.tabsValue)
      }
    },
    submitValues (type) {
      let returnObj = {
        filter: {}
      }
      for (let firstkey in this.chooseVal) {
        let obj = {
          type: firstkey,
          value: this.chooseVal[firstkey]
        }
        this.filterTags[firstkey] = JSON.parse(JSON.stringify(obj.value))
        this.filterTags = JSON.parse(JSON.stringify(this.filterTags))

        let newObj = JSON.parse(JSON.stringify(obj))['value']
        delete newObj['name']
        for (let key in obj['value']['filter']) {
          let list = obj['value']['filter'][key]
          newObj['filter'][key] = []
          if (list.html_type === 'input') {
            newObj['filter'][key] = list['value']
          } else if (list.html_type === 'datetime') {
            for (let k in list['value']) {
              newObj['filter'][key].push(list['value'][k])
            }
          } else {
            for (let k in list['value']) {
              newObj['filter'][key].push(list['value'][k].value)
            }
          }
        }
        returnObj['filter'][firstkey] = newObj
      }
      if (this.checkEmpty(returnObj)) {
        this.$message.error('至少需要选择一项条件！')
        for (let key in this.checkDate) {
          this.checkDate[key] = false
        }
        return false
      }
      for (let key in this.chooseVal) {
        if (this.checkTime.indexOf(key) > -1) {
          if (!this.checkSmallGroupEmpty(this.chooseVal[key]) && !this.chooseVal[key]['child_time'].length) {
            this.tabsValue = key
            this.checkDate[key] = true
            this.checkDate = Object.assign({}, this.checkDate)
            this.$message.error(`当选择了 ${this.filters[key]['name']} 下的条件时，应当同时为 ${this.filters[key]['name']} 选取时间范围！`)
            return false
          }
        }
      }
      this.$emit('getValues', returnObj)
    },
    checkEmpty (obj) {
      let isEmpty = true
      for (let key in obj['filter']) {
        for (let k in obj['filter'][key]['filter']) {
          let item = obj['filter'][key]['filter'][k]
          if (item && item.length) {
            isEmpty = false
          }
        }
      }
      return isEmpty
    },
    checkSmallGroupEmpty (obj) {
      let isEmpty = true
      for (let key in obj['filter']) {
        let item = obj['filter'][key]['value']
        if (item && item.length) {
          isEmpty = false
        }
      }
      return isEmpty
    },
    resetValues (e) {
      for (let key in this.checkDate) {
        this.checkDate[key] = false
      }
      this.filterTags = JSON.parse(JSON.stringify(this.copyDataStr))
      this.chooseVal = JSON.parse(JSON.stringify(this.copyDataStr))
    },
    closeFn () {
      this.$emit('close')
    }
  },
  created () {
    if (JSON.stringify(this.allReadyChoose['filter']) !== '{}') {
      this.initChoose(this.filters)
    }
  },
  mounted () {
    setTimeout(() => {
      this.tabsInit = '1'
    })
    var that = this
    $('body').on('click', '.alinkmore', function () {
      $(this).parents('.filtersbox').find('.filtersconboxul').css('height', '45px')
      that.showMoreBtn()
      if ($(this).parents('.filtersconbox').hasClass('li_search')) {
        $(this).parent().find('ul').eq(0).hide()
        $(this).parent().find('ul').eq(1).show()
        $(this).parent().find('.filtersconboxul').height($(this).parent().find('ul').eq(1).height())
      } else {
        $(this).parent().find('.filtersconboxul').height($(this).parent().find('ul').eq(0).height())
      }
      $(this).hide()
      $(this).parent().find('.alinkhide').show()

      if ($(this).parent().find('ul').length < 2) {
        var allMore = $('.alinkmore')
        for (let i = 0; i < allMore.length; i++) {
          let item = allMore[i]
          if ($(item).parent().find('ul').length > 1) {
            $(item).parent().find('ul').eq(0).show()
            $(item).parent().find('ul').eq(1).hide()
          }
        }
      }
    })
    $('body').on('click', '.alinkhide', function () {
      $(this).parent().find('.filtersconboxul').css('height', '45px')
      $(this).hide()
      $(this).parent().find('.alinkmore').show()
      if ($(this).parents('.filtersconbox').hasClass('li_search')) {
        $(this).parent().find('ul').eq(1).hide()
        $(this).parent().find('ul').eq(0).show()
      }
    })
  }
}
</script>
<style scoped>
.filtersbox {
  border-top: 1px solid #eee;
  font-size: 12px;
}
.filtersitem {
  border-bottom: 1px solid #eee;
  position: relative;
}
.filterstitle {
  width: 150px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  line-height: 30px;
  padding: 10px;
  background: #fcfcfc;
}
.filterscon {
  margin-left: 150px;
  line-height: 30px;
}
.filtersconbox {
  width: 100%;
  position: relative;
  min-height: 50px;
}
.filtersconboxul {
  overflow: hidden;
  padding: 10px 60px 10px 0;
  height: 45px;
}
.tagscontent .filtersconboxul {
  height: auto;
}
.filtersconbox ul {
  height: auto;
  overflow: hidden;
}
.filtersconbox a {
  position: absolute;
  right: 10px;
  top: 10px;
  line-height: 30px;
}
.filtersconbox a span {
  font-size: 12px;
  margin-left: 5px;
}
.filtersconbox ul li {
  float: left;
  cursor: pointer;
  margin-left: 20px;
}
.multip {
  font-size: 14px;
  border-bottom: 1px solid #eee;
  line-height: 30px;
  padding: 10px 0;
  text-indent: 10px;
  /*display: block;*/
  height: auto;
  overflow: hidden;
}
.multip span {
  float: left;
}
li.cur {
  color: #399CFB;
}
.filterbtn {
  text-align: right;
  padding-top: 20px;
}
.filterscroll {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
}
.tagscontent {
  background: #fff;
  padding: 40px 45px;
  margin-bottom: 30px;
}
.tagstitle {
  font-size: 16px;
  margin-bottom: 30px;
}

.tagscontent .filtersconboxul ul li {
  background: #e9f3fe;
  border-radius: 2px;
  color: #81bcfc;
  padding: 0 10px;
  margin: 5px 0 5px 20px;
}
.tagscontent .filtersconboxul ul li span {
  margin-left: 10px;
}
.tagscontent .filtersconboxul ul li.nostyle {
  background: none;
  color: #808080;
  margin: 0 0 0 20px;
  padding: 0;
}

.filters-only-options {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
</style>
